import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';
import { SuccessData } from 'types/api';
import { FullProjectIssue } from '../types';
import { uploadMutations } from 'entities/modules/uploads';

interface ChangeIssueStatusParams {
  status: string;
  project: string;
  issue: string;
}

export const issueMutations = getMutations({
  changeIssueStatus: {
    action: async (payload: ChangeIssueStatusParams): Promise<SuccessData> => {
      return executeApiCall({
        path: '/projects/issues/status',

        method: 'post',

        payload,
      });
    },
  },

  createIssue: {
    action: async (payload: {
      name: string;
      description: string;
      type: string;
      subType: string;
      other: null | string;
      actions: Array<{ action: string; other?: string }>;
      executors: string[];
      sales: string[];
      startDate: string;
      project: string;
    }): Promise<FullProjectIssue> => {
      return executeApiCall({
        path: '/projects/issues',

        method: 'post',

        payload,
      });
    },
  },

  removeUserFromIssue: {
    action: async (payload: {
      issue: string;
      project: string;
      user: string;
      type: string;
    }): Promise<SuccessData> => {
      return executeApiCall({
        path: '/projects/issues/people/remove',

        method: 'post',

        payload,
      });
    },
  },

  addUserToIssue: {
    action: async (payload: {
      issue: string;
      project: string;
      user: string;
      type: string;
    }): Promise<FullProjectIssue['salesInvolved'][number]> => {
      return executeApiCall({
        path: '/projects/issues/people/add',

        method: 'post',

        payload,
      });
    },
  },

  createIssueComment: {
    action: async ({
      files = [],
      ...payload
    }: {
      issue: string;
      project: string;
      text: string;
      files?: File[];
    }): Promise<FullProjectIssue['comments'][number]> => {
      const filePayload = await uploadMutations.multiFileUpload.action({
        files,
        prefix: `projects/${payload.project}`,
      });

      return executeApiCall({
        method: 'post',
        path: 'projects/issues/comments',
        payload: {
          ...payload,
          ...filePayload,
        },
      });
    },
  },

  editIssueComment: {
    action: async (payload: {
      issue: string;
      project: string;
      id: string;
      text: string;
    }): Promise<SuccessData> => {
      return executeApiCall({
        method: 'put',
        path: 'projects/issues/comments',
        payload,
      });
    },
  },

  addActionToIssue: {
    action: async (payload: {
      issue: string;
      project: string;
      action: string;
      other?: string;
    }): Promise<FullProjectIssue['actions'][number]> => {
      return executeApiCall({
        path: '/projects/issues/actions/add',
        payload,
      });
    },
  },
});
